import styled from '@emotion/styled'

import { mediaUp } from '@/styles/media'
import { colors } from '@/styles/theme'

export const FiltersWrapper = styled.div`
  max-width: 263px;
`

export const PinMarkerWrapper = styled.div`
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  width: 30px;
  height: 30px;
`

export const StyledMiniMapImg = styled('img')`
  box-shadow: 0px 4px 24px 0px rgba(9, 55, 105, 0.08);
  border-radius: 12px;
`

export const StyledImageMapWrapper = styled.div`
  position: relative;
  width: fit-content;
`

export const FiltersTitle = styled.div`
  color: ${colors.twilightBlue};
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-top: 0px;

  ${mediaUp('md')} {
    margin-top: 42px;
  }
`

export const ChoosenFilters = styled.div`
  margin-top: 24px;

  ${mediaUp('md')} {
    margin-top: 48px;
  }
`

export const Container = styled.div`
  display: flex;
  padding: 8px 12px;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  border-radius: 21px;
  background: ${colors.paleGrey};
  margin-top: 12px;
  width: fit-content;
`

export const Text = styled.span`
  color: ${colors.twilightBlue};
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 100%;
  letter-spacing: 0%;
  ${mediaUp('md')} {
    font-size: 15px;
  }
  ${mediaUp('lg')} {
    font-size: 18px;
  }
`

export const CloseIcon = styled.img`
  width: 12px;
  height: 12px;
  cursor: pointer;

  ${mediaUp('lg')} {
    width: 20px;
    height: 20px;
  }
`

export const ClearAllFiltersWrapper = styled.div`
  display: flex;
  min-width: 320px;
  margin-top: 24px;
  justify-content: start;
  ${mediaUp('md')} {
    width: 230px;
  }
  ${mediaUp('lg')} {
    width: 320px;
  }
`

export const Divider = styled.div`
  width: 100%;
  height: 2px;
  background-color: #093769;
  margin: 48px auto;
`

export const MobileSortContainer = styled.div`
  margin-top: 24px;
`
